<template>
    <v-dialog v-model="dialog" scrollable width="30%" content-class="drawer" max-width="450px" transition="none">
        <v-card>
            <v-card-title class="d-flex justify-space-between pa-4">
                Enviar formulário
                <v-icon @click="$emit('close')">
                    mdi-close
                </v-icon>
            </v-card-title>
            <v-divider class="mb-5" />
            <v-form v-model="formValid" ref="form">
                <v-card-text>
                    <label class="emailLabel">
                        Preencha o e-mail para quem você deseja enviar o link do formulário abaixo:
                    </label>
                    <v-text-field
                        outlined
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                        class="mt-5"
                    ></v-text-field>
                </v-card-text>
            </v-form>
            <v-divider />
            <v-card-actions>
                <v-btn
                    :loading="loading"
                    :disabled="!formValid"
                    color="primary"
                    class="w-100 mb-4"
                    @click="sendEmail"
                >
                    Enviar
                </v-btn>
            </v-card-actions>

            <response-modal
                :show-dialog="dialogResponseShow"
                :type="dialogResponseType"
                :message="dialogResponseMessage"
                @close="closeModalResponse"
            />
        </v-card>
    </v-dialog>
</template>
<script>
import ResponseModal from "../Modals/ResponseModal.vue";

export default {
    name: 'SendLinkToEmail',
    components: { ResponseModal },
    props: {
        showDialog: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        dialog: false,
        loading: false,
        email: '',
        formValid: false,
        emailRules: [
            v => !!v || 'O email é obrigatório',
            v => !!v.match('^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$') || 'O email é inválido',
        ],
        dialogResponseShow: false,
        dialogResponseType: '',
        dialogResponseMessage: ''
    }),
    methods: {
        responseModal(type, message) {
            this.dialogResponseType = type;
            this.dialogResponseMessage = message;
            this.dialogResponseShow = true;
        },
        closeModalResponse() {
            this.dialogResponseShow = false;
            this.$router.push({ name: 'hotelsApprove' });
        },
        sendEmail() {
            if (!this.$refs.form.validate()) return;
            this.loading = true;
            const query = { emails: [this.email] };
            axios.post('api/hotel/send-register-form', query)
                .then((res) => {
                    let type = 'success';
                    if( res.data.success === false ) {
                        type = 'error';
                    }
                    this.responseModal(type, res.data.message);
                    this.dialog = false;
                }).catch(() => {
                this.responseModal('error', 'Erro ao enviar email. Tente novamente');
                this.dialog = false;
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    watch: {
        showDialog() {
            if (this.dialog !== this.showDialog) this.dialog = this.showDialog;
        },
        dialog(value) {
            if (value === false) this.$emit('close');
        }
    }
}
</script>
<style scoped>
>>> .drawer {
    margin: 0;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    transition: transform 0.2s;
}

>>> .none-enter-active {
    transform: translateX(100%);
}

>>> .none-leave-active {
    transform: translateX(100%);
}

.v-dialog__content {
    justify-content: flex-end;
}

.emailLabel {
    color: #1D2231;
    font-size: 1rem;
}
</style>
